module.exports = "/assets/5022edcc77df23310be222d97a16b44d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PD.png
// module id = 2836
// module chunks = 0